import { BasicAsyncSelect } from '@/view/components/BasicAsyncSelect'
import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { useCallback } from 'react'
import { MultiValue } from 'react-select'
import { OptionType } from '@/app/utils/optionSelectType'
import { useSellers } from '@/app/hooks/useSellers'
import { UserRoleEnum } from '@/app/services/usersService/user'
interface SupportUsersProps {
  opt: MultiValue<OptionType>
  setOpt: React.Dispatch<React.SetStateAction<MultiValue<OptionType>>>
}
export default function SupportUsers({ opt, setOpt }: SupportUsersProps) {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<FilterFormData>()

  const handleSelectSupports = (
    selectedSupportsOptions: MultiValue<OptionType>,
  ) => {
    const value =
      selectedSupportsOptions?.map((option) => option.value) || undefined

    setValue('supportIds', value as unknown as string)
    setOpt(selectedSupportsOptions)
  }

  const {
    data: fullSupportData,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    setParams: setParamsSupports,
  } = useSellers({ initialLimit: 10, role: UserRoleEnum.SUPPORT })

  const supportData = fullSupportData?.pages.flatMap((page) =>
    page.users.map((user) => ({
      value: user._id,
      label: user.name,
    })),
  )

  const handleLoadMore = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [fetchNextPage, hasNextPage, isFetching])

  return (
    <div className={'space-y-2'}>
      <h3 className="font-medium text-black04">Quem pesquisou</h3>
      <BasicAsyncSelect
        data={supportData}
        handleSelectedValue={handleSelectSupports}
        isLoading={isFetching || isLoading}
        onMenuScrollToBottom={handleLoadMore}
        placeholder="Selecione quem pesquisou"
        setParams={setParamsSupports}
        value={opt}
        inputError={errors.supportIds?.message}
      />
    </div>
  )
}
